import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import Cookies from "js-cookie";

import { Button, Icon } from "tabler-react";

function TelegramDisconnectButton({ t, onDisconnectComplete }) {
    const [isLoading, setIsLoading] = useState(false);

    const handleDisconnectClick = () => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className="custom-ui">
                        <h1>
                            <Icon
                                name="alert-triangle"
                                className="text-warning mr-2"
                            />
                            {t(
                                "shop.account.telegram.disconnect_confirm_title",
                            )}
                        </h1>
                        <p>
                            {t(
                                "shop.account.telegram.disconnect_confirm_message",
                            )}
                        </p>
                        <ul className="list-unstyled text-muted">
                            <li className="mb-1">
                                <Icon name="x" className="text-danger mr-2" />
                                {t(
                                    "shop.account.telegram.disconnect_consequence_notifications",
                                )}
                            </li>
                            <li className="mb-1">
                                <Icon name="x" className="text-danger mr-2" />
                                {t(
                                    "shop.account.telegram.disconnect_consequence_updates",
                                )}
                            </li>
                        </ul>
                        <p className="text-info">
                            <Icon name="info" className="mr-2" />
                            {t(
                                "shop.account.telegram.disconnect_reconnect_note",
                            )}
                        </p>
                        <button
                            className="btn btn-link pull-right"
                            onClick={onClose}
                        >
                            {t("general.cancel")}
                        </button>
                        <button
                            className="btn btn-danger"
                            onClick={() => {
                                handleConfirmDisconnect();
                                onClose();
                            }}
                        >
                            <Icon name="x-circle" className="mr-2" />
                            {t(
                                "shop.account.telegram.disconnect_confirm_button",
                            )}
                        </button>
                    </div>
                );
            },
        });
    };

    const handleConfirmDisconnect = async () => {
        setIsLoading(true);

        try {
            // Call API to disconnect telegram account
            const response = await fetch("/d/api/telegram/disconnect/", {
                method: "DELETE",
                credentials: "same-origin",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": Cookies.get("csrftoken"),
                },
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(
                    errorData.error ||
                        t("shop.account.telegram.error_disconnecting"),
                );
            }

            await response.json();

            toast.success(t("shop.account.telegram.disconnect_success"), {
                position: toast.POSITION.BOTTOM_RIGHT,
            });

            // Notify parent component that disconnection is complete
            if (onDisconnectComplete) {
                onDisconnectComplete();
            }
        } catch (error) {
            console.error("Error disconnecting telegram:", error);
            toast.error(
                error.message || t("shop.account.telegram.error_disconnecting"),
                {
                    position: toast.POSITION.BOTTOM_RIGHT,
                },
            );
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Button
            color="danger"
            outline
            icon="x-circle"
            onClick={handleDisconnectClick}
            loading={isLoading}
            disabled={isLoading}
        >
            {t("shop.account.telegram.disconnect_button")}
        </Button>
    );
}

export default withTranslation()(TelegramDisconnectButton);
